import { Component, OnInit, Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { FilterableService } from '../../../../filterable-service';
import { WorkOrderFileUploadComponent } from '../../../work-order-file-upload/work-order-file-upload.component';
import { AppService } from '../../../../../../app.service';
import { Validators } from '@angular/forms';
import {
  AuthorizationService,
  ProgramDetailsBodyService,
  PlantService, AreaService,
  ZoneService, GateService,
  RequestTypeService,
  DeliverablesService,
  TotalVehicleNumberService,
  MBOMService,
  TrackingVehicleNumberService,
  DocumentService
} from '../../../../ve.service';

const PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE = 'Body tracking vehicle by program.';
const TOTAL_NUMBER_TRACKING_VEHICLE_NUMBER_TYPE = 'Body tracking vehicle by total number.';
const TOTAL_VEHICLE_NUMBER = 'Total Vehicle Number';
const ACTIVE_ONLY_REQUEST = '?activeOnly=true';
const ALL_REQUEST = '?activeOnly=false';

@Component({
  selector: 'body-main-form',
  templateUrl: './body-main-form.component.html',
  styleUrls: [
    '../../../work-orders.component.scss',
    './body-main-form.component.scss',
  ]
})
export class BodyMainFormComponent  extends WorkOrderFileUploadComponent implements OnInit {
  workOrdersService: WorkOrdersService;
  bodyUserService: AuthorizationService;
  programDetailsService: ProgramDetailsBodyService;
  bodyPlantService: PlantService;
  bodyAreaService: AreaService;
  bodyZoneService: ZoneService;
  bodyGateService: GateService;
  bodyRequestTypeService: RequestTypeService;
  bodyDeliverableService: DeliverablesService;
  bodyTotalVehicleNumberService: TotalVehicleNumberService;
  bodymBomService: MBOMService;
  bodyTrackingVehicleNumberService: TrackingVehicleNumberService;
  documentService: DocumentService;

  requestorService = new FilterableService();
  programService = new FilterableService();
  plantService = new FilterableService();
  areaService = new FilterableService();
  zoneService = new FilterableService();
  gateService = new FilterableService();
  requestTypeService = new FilterableService();
  deliverableService = new FilterableService();
  totalVehicleNumberService = new FilterableService();
  mBomService = new FilterableService();
  trackingVehicleNumberService = new FilterableService();
  documentTypesService = new FilterableService();
  documentsService = new FilterableService();

  totalmBomSelectionList = [TOTAL_VEHICLE_NUMBER, 'mBom'];

  private readonly _fullScreenToggled: any;
  date: any;
  editForm: any;

  constructor(injector: Injector, private readonly appService: AppService) {
    super(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.bodyUserService = injector.get(AuthorizationService);
    this.programDetailsService = injector.get(ProgramDetailsBodyService);
    this.bodyPlantService = injector.get(PlantService);
    this.bodyAreaService = injector.get(AreaService);
    this.bodyZoneService = injector.get(ZoneService);
    this.bodyGateService = injector.get(GateService);
    this.bodyRequestTypeService = injector.get(RequestTypeService);
    this.bodyDeliverableService = injector.get(DeliverablesService);
    this.bodyTotalVehicleNumberService = injector.get(TotalVehicleNumberService);
    this.bodymBomService = injector.get(MBOMService);
    this.bodyTrackingVehicleNumberService = injector.get(TrackingVehicleNumberService);
    this.documentService = injector.get(DocumentService);
    this.editForm = this.workOrdersService.bodyMainEditForm;
    this._fullScreenToggled = appService.fullScreenToggled.subscribe((isFullScreen) => {
      isFullScreen ? this.workOrdersService.groupcss = 'groupFullScreen' : this.workOrdersService.groupcss = 'group';
    });
  }

  ngOnInit() {
    this.appService.isFullScreen() ? this.workOrdersService.groupcss = 'groupFullScreen' : this.workOrdersService.groupcss = 'group';
    this.setRequestDate();

    this.fileUploadService.uploadSaveUrl = this.documentService.getUploadUrl('VE_Body', false);
    this.fileUploadService.fileType = 'Instructions';
    this.fileUploadService.workOrderId = this.workOrdersService.bodyMainEditForm.get('Id').value;

    Promise.all([
      this.getRequestors(),
      this.getPrograms(),
      this.getAreas(),
      this.getGates(),
      this.getRequestTypes(),
      // this.fileUploadService.getDocumentTypes(),
      // this.fileUploadService.getDocuments()
      this.fileUploadService.getFiles()
    ]).then(() => {
      if (!this.workOrdersService.isNewWO || this.workOrdersService.isCopyWO) {
        this.getEditData();
      }
    });
  }

  getEditData() {
    const programId = this.workOrdersService.editData.ProgramId;
    const areaId = this.workOrdersService.editData.AreaId;
    const requestTypeId = this.workOrdersService.editData.RequestTypeId;
    const totalVehicleId = this.workOrdersService.editData.TotalVehicleNumberId;
    this.handleProgramChange(programId, true);
    this.handleAreaChange(areaId);
    this.handleRequestTypeChange(requestTypeId, true);
    this.handleTotalVehicleChange(totalVehicleId, true);
  }

  setRequestDate() {
    const date = new Date();
    this.editForm.get('RequestDate').setValue(date);
  }

  getRequestors(): Promise<any> {
    return this.bodyUserService.read('/moduleusers?moduleName=VE_Body')
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Name.localeCompare(b.Name));
        }
        this.requestorService.next(result);
      });
  }

  getPrograms(): Promise<any> {
    return this.programDetailsService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
        }
        this.programService.next(result);
      });
  }

  getPlants(progamId): Promise<any> {
    return this.bodyPlantService.read(`ByProgram/${progamId}`)
      .then(plants => {
        if (plants.length > 0) {
          plants.sort((a, b) => a.PlantDescription.localeCompare(b.PlantDescription));
        }
        this.plantService.next(plants);
      });
  }

  getAreas(): Promise<any> {
    return this.bodyAreaService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.areaService.next(result);
      });
  }

  getGates(): Promise<any> {
    return this.bodyGateService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(result => {
        this.gateService.next(result);
      });
  }

  getRequestTypes(): Promise<any> {
    return this.bodyRequestTypeService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.requestTypeService.next(result);
      });
  }

  getmBoms(programId): Promise<any> {
    return this.bodymBomService.read(`/programid/${programId}${this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST}`)
      .then(bodymBom => {
        if (bodymBom.length > 0) {
          bodymBom.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.mBomService.next(bodymBom);
      });
  }

  getTrackingVehicleNumbers(searchId, searchType): Promise<any> {
    return this.trackingVehicleSearchServices[`${searchType}`](searchId)
      .then(trackingVehicleNumber => {
        if (trackingVehicleNumber.length > 0) {
          trackingVehicleNumber.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.trackingVehicleNumberService.next(trackingVehicleNumber);
      });
  }

  getTotalVehicleNumbers(programId): Promise<any> {
    return this.bodyTotalVehicleNumberService.read(`/programid/${programId}`)
      .then(totalVehicleNumbers => {
        if (totalVehicleNumbers.length > 0) {
          totalVehicleNumbers.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.totalVehicleNumberService.next(totalVehicleNumbers);
      });
  }

  getStudyName = () => {
    const program = this.programService.value ?
    this.programService.value.filter(x => x.ProgramId === this.editForm.get('ProgramId').value) :
    '';
    const gate = this.gateService.value ?
    this.gateService.value.filter(x => x.Id === this.editForm.get('GateId').value) :
    '';
    const deliverable = this.deliverableService.value ?
    this.deliverableService.value.filter(x => x.Id === this.editForm.get('DeliverableId').value) :
    '';
    const mfgStudy = this.editForm.get('MfgStudyTitle').value;
    const mBom = this.mBomService.value ?
    this.mBomService.value.filter(x => x.Id === this.editForm.get('MbomId').value) :
    '';
    const totalVeh = this.totalVehicleNumberService.value ?
    this.totalVehicleNumberService.value.filter(x => x.Id === this.editForm.get('TotalVehicleNumberId').value) :
    '';
    const trackVeh = this.trackingVehicleNumberService.value ?
    this.trackingVehicleNumberService.value.filter(x => x.Id === this.editForm.get('TrackingVehicleNumberId').value) :
    '';
    const area = this.areaService.value ?
    this.areaService.value.filter(x => x.Id === this.editForm.get('AreaId').value) :
    '';

    let studyName = '';

    studyName += program.length > 0 ? `${program[0].ProgramCode} ` : '';
    studyName += gate.length > 0 ? `${gate[0].Description} ` : '';
    studyName += mfgStudy ? `${mfgStudy} ` : '';
    studyName += deliverable.length > 0 ? `${deliverable[0].Description} ` : '';
    studyName += mBom.length > 0 ? `${mBom[0].Description} ` : '';
    studyName += totalVeh.length > 0 ? `${totalVeh[0].Description} ` : '';
    studyName += trackVeh.length > 0 ? `${trackVeh[0].Description} ` : '';
    studyName += area.length > 0 ? `${area[0].Description} ` : '';

    studyName = studyName.trim();
    this.editForm.get('StudyName').setValue(studyName);
    return studyName;
  }

  getProgramRelatedFields(programId, firstRender) {
    this.getmBoms(programId);
    this.getTrackingVehicleNumbers(programId, PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE);
    if (this.isTotalVehicle()) {
      this.getTotalVehicleNumbers(programId);
    }
    if (!firstRender) {
      this.setUserFields();
    }
    this.getPlants(programId);
  }

  setUserFields() {
    const program = this.programService.value
    .filter(x => x.ProgramId === this.editForm.get('ProgramId').value);

    if (program.length > 0) {
      this.editForm.get('VELead').setValue(program[0].VELead);
      this.editForm.get('VELeadName').setValue(program[0].VELeadName);
      this.editForm.get('PIE').setValue(program[0].PIE);
      this.editForm.get('PIEName').setValue(program[0].PIEName);
      this.editForm.get('PLL').setValue(program[0].PLL);
      this.editForm.get('PLLName').setValue(program[0].PLLName);
      this.editForm.get('DispenseEngineer').setValue(program[0].DispenseEngineer);
      this.editForm.get('DispenseEngineerName').setValue(program[0].DispenseEngineerName);
      this.editForm.get('BiwManager').setValue(program[0].BiwManager);
      this.editForm.get('BiwManagerName').setValue(program[0].BiwManagerName);
      this.editForm.get('WeldEngineer').setValue(program[0].WeldEngineer);
      this.editForm.get('WeldEngineerName').setValue(program[0].WeldEngineerName);
    }
  }

  handleProgramChange = (programId: any, firstRender) => {
    if (programId) {
      if (!firstRender) {
        this.clearProgramRelatedFields();
      }
      this.getProgramRelatedFields(programId, firstRender);
    }
  }

  clearProgramRelatedFields() {
    const programFields = [
      'PlantId',
      'TrackingVehicleNumberId',
      'TotalVehicleNumberId',
      'MbomId',
      'VELead',
      'VELeadName',
      'PIE',
      'PIEName',
      'PLL',
      'PLLName',
      'BiwManager',
      'BiwManagerName',
      'WeldEngineer',
      'WeldEngineerName',
      'DispenseEngineer',
      'DispenseEngineerName'];

    programFields.forEach(element => {
      const formItem = this.editForm.get(element);
      if (formItem.value) {
        formItem.setValue(null);
      }
    });
  }

  handleRequestTypeChange = (event, firstRender) => {
    if (!firstRender) {
    this.editForm.get('DeliverableId').setValue(null);
    this.editForm.get('MfgStudyTitle').setValue(null);
    }

    if (event) {
      const requestType = this.requestTypeService.value.filter(x => x.Id === event);
      this.bodyDeliverableService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
        .then(result => {
          const deliverables = result.filter(x => x.RequestTypeId === requestType[0].Id);
          if (deliverables.length > 0) {
            deliverables.sort((a, b) => a.Description.localeCompare(b.Description));
          }
          this.deliverableService.next(deliverables);
        });
    }
  }

  handleAreaChange = (areaId) => {
    if (areaId) {
      this.bodyZoneService.read(`ByArea/${areaId}`)
        .then(result => {
          if (result.length > 0) {
            result.sort((a, b) => a.Description.localeCompare(b.Description));
          }
          this.zoneService.next(result);
        });
    } else {
      this.editForm.get('ZoneId').setValue(null);
    }
  }

  handleTotalVehicleMbomChange = () => {
    const selectedValue = this.editForm.get('totalmBomSelected').value;

    if (selectedValue === TOTAL_VEHICLE_NUMBER) {
      this.editForm.get('TotalVehicleNumberId').setValidators([Validators.required]);
      this.editForm.get('TrackingVehicleNumberId').setValidators([Validators.required]);
      this.resetMbom();
    } else if (selectedValue === 'mBom') {
      this.editForm.get('MbomId').setValidators([Validators.required]);
      this.resetTotalVehicleNumber();
    } else {
      this.resetTotalVehicleNumber();
      this.resetMbom();
    }
  }

  handleTotalVehicleChange = (totalVehicleId, firstRender) => {
    const programId = this.editForm.get('ProgramId').value;

    if (!firstRender) {
      this.editForm.get('TrackingVehicleNumberId').setValue(null);
    }
    if (totalVehicleId) {
      this.getTrackingVehicleNumbers(totalVehicleId, TOTAL_NUMBER_TRACKING_VEHICLE_NUMBER_TYPE);
    } else if (programId && !totalVehicleId) {
      this.getTotalVehicleNumbers(programId);
      this.getTrackingVehicleNumbers(programId, PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE);
    }
  }

  resetTotalVehicleNumber() {
    this.editForm.get('TotalVehicleNumberId').setValidators(null);
    this.editForm.get('TotalVehicleNumberId').setErrors(null);
    this.editForm.get('TotalVehicleNumberId').setValue(null);
    this.editForm.get('TrackingVehicleNumberId').setValidators(null);
    this.editForm.get('TrackingVehicleNumberId').setErrors(null);
    this.editForm.get('TrackingVehicleNumberId').setValue(null);
  }

  resetMbom() {
    this.editForm.get('MbomId').setValidators(null);
    this.editForm.get('MbomId').setErrors(null);
    this.editForm.get('MbomId').setValue(null);
    this.editForm.get('TrackingVehicleNumberId').setValue(null);
    const programId = this.editForm.get('ProgramId').value;
    if (programId) {
      this.getTrackingVehicleNumbers(programId, PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE);
      this.getTotalVehicleNumbers(programId);
    } else {
      this.trackingVehicleNumberService.next(null);
    }
  }

  isTotalVehicle = () => {
    return this.editForm.get('totalmBomSelected').value === TOTAL_VEHICLE_NUMBER;
  }

  isMFGStudy = () => {
    const selectedRequestTypeId = this.editForm.get('RequestTypeId').value;
    const requestType = this.requestTypeService.value.filter(x => x.Id === selectedRequestTypeId);

    const isMfgStudy: boolean = requestType.length > 0
      ? requestType[0].Description === 'Mfg Study'
      : false;

    if (isMfgStudy) {
      this.editForm.get('MfgStudyTitle').setValidators([Validators.required]);
    } else {
      this.editForm.get('MfgStudyTitle').setValidators(null);
      this.editForm.get('MfgStudyTitle').setErrors(null);
    }

    return isMfgStudy;
  }

  /**
  * Service object function mapper for common search endpoints between GA and Body.
  *
  * @readonly
  * @memberof WorkOrderScheduleEditService
  */
  get trackingVehicleSearchServices() {
    return {
      [`${PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE}`]: (programId) => this.bodyTrackingVehicleNumberService.read(`/programid/${programId}`),
      [`${TOTAL_NUMBER_TRACKING_VEHICLE_NUMBER_TYPE}`]: (totalVehicleNumber) => this.bodyTrackingVehicleNumberService.read(`/totalvehiclenumberid/${totalVehicleNumber}`),
    };
  }
}
